export class Money {
  constructor({
    amount,
    currency,
  }: {
    readonly amount: number;
    readonly currency: Currency;
  }) {
    this.amount = amount;
    this.currency = currency;
  }

  readonly amount: number;
  readonly currency: Currency;
}

export enum Currency {
  EUR = 'EUR',
  CHF = 'CHF',
}
